import React from 'react';

import LinkArrowRight from '@/components/Elements/LinkArrowRight/LinkArrowRight';
import Paragraph from '@/components/Elements/Paragraph/Paragraph';

import { PortfolioParagraphContentProps } from '@/helpers/getParagraphForDynamicPage';

import { IDescription } from '@/types/types';

import './DynamicCta.scss';

interface Props extends PortfolioParagraphContentProps {
  title: string;
  description: IDescription;
}

const DynamicCta = ({ title, description }: Props) => (
  <div className="DynamicCta_wrapper">
    <div className="DynamicCta_container">
      <div className="DynamicCta_title">
        <Paragraph item={description} paragraphClass="DynamicCta_paragraph h6" />
      </div>
      <div className="DynamicCta_description">
        <LinkArrowRight
          title={title}
          link="contact-form"
          isHashLink
          customClass="Cta_button button-2 button-func button-yellow"
          arrowSize="medium"
        />
      </div>
    </div>
  </div>
);

export default DynamicCta;
